<template>
  <LayoutDefault>
    <ModulesListEducation/>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'
import ModulesListEducation from '@/components/blocks/ModulesListEducation.vue'

export default {
  name: 'ModulesEducationView',
  components: {
    LayoutDefault,
    ModulesListEducation
  },
  props: {
  },
  setup () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
